import type { NextPage } from "next";

interface Props {
  height?: string;
  width?: string;
  color?: string;
  className?: string;
}

const KlubDivingIcon: NextPage<Props> = ({
  width = "100%",
  height = "100%",
  color = "#52A4FF",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.3772 8V36.1264H8.08769V8H17.3772Z" fill={color} />
      <path
        d="M54.7379 64.0556C61.1295 64.0773 66.3445 69.3341 66.3114 75.7218C66.2782 82.1144 61.0126 87.3221 54.6273 87.2773C48.2645 87.2326 43.0823 82.0088 43.0924 75.6499C43.1026 69.2587 48.3504 64.034 54.7379 64.0556ZM52.4282 73.3584V77.9336H56.9619V73.3584H52.4282Z"
        fill={color}
      />
      <path
        d="M39.2652 80.2392C38.2297 77.202 38.2489 74.157 39.2891 70.9902H36.9196C35.4745 70.9902 34.1846 71.0434 32.9003 70.9814C25.8685 70.6418 19.755 65.666 17.9348 58.8954C17.308 56.5639 17.3842 54.1983 17.3774 51.8292C17.3758 51.2725 17.3772 50.7157 17.3772 50.1173H8.12697C6.44113 70.6638 21.836 81.5638 36.8957 80.2392L39.2652 80.2392Z"
        fill={color}
      />
      <path
        d="M17.3326 45.4352H8.14601V40.8772H17.3326V45.4352Z"
        fill={color}
      />
      <path
        d="M36.8953 50.052C37.9651 50.0872 39.0308 50.0843 40.1021 50.052H36.8953Z"
        fill={color}
      />
      <path
        d="M86.6062 31.8026C84.6429 26.1824 79.7364 22.6136 73.7788 22.3118C73.6306 22.4544 34.6878 22.3411 34.2237 22.3988C27.5132 23.2371 22.2618 28.9935 22.035 35.7425C21.8094 42.4676 26.6802 48.6805 33.3665 49.7674C34.1353 49.8924 34.9261 49.9032 35.709 49.9564C36.2459 49.4168 44.7767 40.8177 54.6991 40.8177C64.8668 40.8177 73.6239 49.8973 73.7789 50.0389V50.0487C73.9273 50.0379 74.0787 50.0472 74.2266 50.0345C80.0855 49.5399 84.2118 46.4681 86.4373 40.9916C86.878 39.9066 87.0579 38.7166 87.3585 37.5746V34.7874C87.1116 33.7908 86.9434 32.7674 86.6062 31.8026Z"
        fill={color}
      />
      <path
        d="M68.8777 50.052C70.4764 50.1487 72.0774 50.1629 73.6668 50.052H68.8777Z"
        fill={color}
      />
      <path
        d="M35.625 50.0658V50.0524L73.7789 50.0487V50.0658C73.6313 50.2074 64.8669 59.2867 54.705 59.2867C44.5371 59.2867 35.7801 50.2074 35.625 50.0658Z"
        fill={color}
      />
    </svg>
  );
};

export default KlubDivingIcon;
